import { Component } from 'react'
import { connect } from 'react-redux'
import { MY_ACTIVE_FETCH_REQ } from 'components/Dashboard/actions'
import ComponentFrame from 'components/Dashboard/ComponentFrame/ComponentFrame'
import s from './MyActive.scss'
import toMyActive from './serializers'
import { URLS } from 'utils/constants'
import { NavLink } from 'react-router-dom'
import { ComponentSpinner } from '../ComponentSpinner'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class MyActiveContainer extends Component {
  componentDidMount() {
    this.props.dispatch({
      type: MY_ACTIVE_FETCH_REQ
    })
  }

  render() {
    const { myActive } = this.props.dashboard
    const data = toMyActive(myActive)
    const activeTypes = Object.keys(data)
    return (
      <ComponentFrame
        title="My Active Opportunities and Proposals by Stage"
        subTitle="Listed below are active opportunities and proposals that you are involved in."
      >
        {activeTypes.length === 0 && <ComponentSpinner />}
        <div className={s.myActiveWrapper}>
          {activeTypes.map(elType => (
            <div className={s.myActiveContainer} key={elType}>
              <div className={s.activeTypeTitle}>{data[elType].title}</div>
              <table>
                <tbody>
                  {data[elType].list.map(el => (
                    <tr key={el.id}>
                      <td>
                        <NavLink
                          to={elType === 'myOpenDeals' ? URLS.AUTH_DEALS : URLS.AUTH_PROPOSALS}
                          className={s.activeName}
                        >
                          {el.name}
                        </NavLink>
                      </td>
                      <td className={s.activeValue}>{el.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </ComponentFrame>
    )
  }
}

export default MyActiveContainer
